// @flow
// A loadableConfirmPage returns the default component mapping,
// but overrides the button with a button with macros.

import { setComponentMapping } from '@leasen_nl/listo/src/context/componentMapping';
import { withMacrosButton } from '@leasen_nl/listo/src/components/button';
import Page from '@leasen_nl/listo/src/components/page';
import componentMapping from '../../componentMapping';
import contract from '../../wp-contract';
import Button from '../button';

const replacedMapping = {
  ...componentMapping,
  button: withMacrosButton<$Exact<{}>>(Button, contract.macros),
};

type Props = {|
  acf: any,
|};

export default setComponentMapping(replacedMapping)<Props>(Page);
